import styled, { css } from 'styled-components';
import Icon from '@/components/Icon';

export const TitleContainer = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  width: 100%;
  background-color: ${props => props.theme.help.background};
  cursor: pointer;
`;

export const Title = styled.p`
  // TODO: Decouple this element from these generic theme props.
  font-family: ${props => props.theme.help.fontFamilyText};
  color: ${props => props.theme.help.titleColor};

  ${({ theme }) =>
    theme.help.description &&
    css`
      font-family: ${theme.help.description.fontFamily};
      font-size: ${theme.help.description.fontSize};
      font-weight: ${theme.help.description.fontWeight};
      line-height: 150%;
      text-transform: ${theme.help.description.textTransform};
      color: ${theme.help.description.textTransform};
    `}
`;

export const ArrowIcon = styled(Icon).withConfig({
  shouldForwardProp: prop => prop === 'iconName',
})`
  stroke: ${props => props.theme.help.arrowColor};
  margin-right: 1rem;
  width: 2rem;
`;

const descriptionSharedStyles = css`
  padding: 2rem 0 0;
  // TODO: Decouple this element from these generic theme props.
  color: ${props => props.theme.help.textColor};
  font-family: ${props => props.theme.help.fontFamilyText};
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.1rem;
`;

export const Description = styled.p`
  ${descriptionSharedStyles};
`;

export const CookiesDescription = styled.div`
  ${descriptionSharedStyles};
`;

export const AccordionItemContainer = styled.div`
  padding: 2rem 4rem;
  cursor: pointer;
`;

export const StyledAccordionItem = styled.li`
  list-style-type: none;
  margin: 0;
  background-color: none;

  hr {
    border: 0.05rem solid #d8d8d8;
    margin: 0 4rem;
  }

  &:not(:only-child):last-child {
    hr {
      display: none;
    }
  }
`;
